module.exports = __webpack_public_path__ + "0704d1c7bbf887ddc5d65595ab641e4d.woff2";